<template>
  <div>
    <router-view v-if="!$route.meta.keepAlive" />
    <keep-alive v-else>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>
<script>
export default {
  name: '',
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style scoped lang="scss">
</style>
